<template>
  <component v-if="component" v-bind="$attrs" :is="component" />
  <FontAwesomeIcon
    v-else-if="source === 'font-awesome'"
    v-bind="$attrs"
    :icon="name"
  />
  <span
    v-else-if="source === 'custom'"
    v-bind="$attrs"
    :class="customIconClass"
  />
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library as fontAwesomeIconLibrary } from '@fortawesome/fontawesome-svg-core'
import camelCase from 'lodash/camelCase'
import {
  faSignInAlt,
  faSignOutAlt,
  faGlobeAmericas,
} from '@fortawesome/free-solid-svg-icons'
// https://fontawesome.com/icons
fontAwesomeIconLibrary.add(faGlobeAmericas, faSignInAlt, faSignOutAlt)

export default {
  components: {
    FontAwesomeIcon,
  },
  inheritAttrs: false,
  props: {
    component: {
      type: Object,
      required: false,
    },
    source: {
      type: String,
      default: 'font-awesome',
      required: false,
    },
    name: {
      type: [String, Array],
      required: false,
    },
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    customIconClass() {
      return this.$style[camelCase('icon-custom-' + this.name)]
    },
  },
}
</script>
